import React from 'react'
import { useLocation } from 'react-router-dom'
import paths from '../../routes/paths'
import { countAmountFromList } from '../../utils'

import CartShortcut from '../../components/cart/shortcut'
import useOrder from '../../hooks/useOrder'
import useDevices from '../../hooks/useDevices'

const pathIncludes = [paths.listFood, paths.home]

const CardShortcutContainer = props => {
    const location = useLocation();
    const { foodsOrdering, totalOrdering } = useOrder();
    const { isDesktop } = useDevices();

    const countOrdering = countAmountFromList(foodsOrdering);
    const hideCart = isDesktop || !pathIncludes.find(path => path === location.pathname);

    return (
        <CartShortcut
            total={totalOrdering}
            hideCart={hideCart}
            countNewOrder={countOrdering}
            {...props}
        />
    )
}

export default CardShortcutContainer
